import { render, staticRenderFns } from "./TrackingOrders.vue?vue&type=template&id=2d0d1dfa&"
import script from "./TrackingOrders.vue?vue&type=script&lang=js&"
export * from "./TrackingOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports